import React from 'react';
import styled from 'styled-components';
import { AlertTriangle, TrendingDown } from 'lucide-react';

const Wrap = styled.div`
  padding: 1.25rem 1.25rem 2rem;
  color: #cbd5e1;
`;

const Heading = styled.div`
  display: flex;
  align-items: center;
  gap: 0.65rem;
  color: #e2e8f0;
  font-size: 1.05rem;
  font-weight: 600;

  svg { color: #fb7185; }
`;

const Subtitle = styled.div`
  margin: 0.3rem 0 1.25rem 1.75rem;
  color: #94a3b8;
  font-size: 0.78rem;
`;

const Notice = styled.div`
  padding: 1.25rem;
  display: flex;
  gap: 0.85rem;
  color: #cbd5e1;
  background: rgba(245, 158, 11, 0.08);
  border: 1px solid rgba(245, 158, 11, 0.35);
  border-radius: 10px;
  line-height: 1.55;

  svg {
    flex: 0 0 auto;
    color: #fbbf24;
    margin-top: 0.1rem;
  }

  strong { color: #f8fafc; }
  p { margin: 0.35rem 0 0; color: #94a3b8; }
`;

/**
 * Phase-1 fail-closed view. Portfolio CPR/CDR cannot be published from
 * facility-level legacy prepayment records or deprecated facility balances.
 */
const PrepaymentForecastPanel: React.FC = () => (
  <Wrap>
    <Heading>
      <TrendingDown size={18} />
      Prepayment Forecast — Phase 2
    </Heading>
    <Subtitle>Portfolio-scoped CPR/CDR analytics</Subtitle>

    <Notice role="status">
      <AlertTriangle size={22} />
      <div>
        <strong>CPR/CDR modeling unavailable in Phase 1</strong>
        <p>
          No rate was published. Canonical loan event applications are portfolio scoped, but
          Phase 1 does not yet classify paydowns as voluntary, mandatory, or default and does
          not provide the authoritative historical IBOR exposure series required for the
          denominator. Facility balances are not used as a substitute.
        </p>
      </div>
    </Notice>
  </Wrap>
);

export default PrepaymentForecastPanel;
